import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["fill", "stroke"]
const _hoisted_2 = ["fill"]
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["fill"]
const _hoisted_7 = ["fill"]
const _hoisted_8 = ["fill"]
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["stroke"]
const _hoisted_11 = ["fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PetGroupLogo',
  props: {
    size: {},
    variant: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex items-center gap-2.5", {'gap-2': _ctx.size === 'sm'}])
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass([
        _ctx.size === 'sm' ? 'w-8 h-8' : _ctx.size === 'lg' ? 'w-14 h-14' : 'w-10 h-10',
      ]),
      viewBox: "0 0 64 64",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      "aria-label": "Logo"
    }, [
      _createElementVNode("circle", {
        cx: "32",
        cy: "32",
        r: "30",
        fill: _ctx.variant === 'white' ? 'rgba(255,255,255,0.15)' : '#f0fdfa',
        stroke: _ctx.variant === 'white' ? 'rgba(255,255,255,0.3)' : '#99f6e4',
        "stroke-width": "1.5"
      }, null, 8, _hoisted_1),
      _createElementVNode("g", {
        fill: _ctx.variant === 'white' ? '#ffffff' : '#0d9488'
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("ellipse", {
          cx: "24",
          cy: "38",
          rx: "8",
          ry: "10",
          opacity: "0.9"
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("circle", {
          cx: "22",
          cy: "26",
          r: "7"
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("ellipse", {
          cx: "16",
          cy: "21",
          rx: "3.5",
          ry: "5",
          transform: "rotate(-15 16 21)"
        }, null, -1)),
        _createElementVNode("circle", {
          cx: "18",
          cy: "27",
          r: "1.5",
          fill: _ctx.variant === 'white' ? '#0d9488' : '#134e4a'
        }, null, 8, _hoisted_3),
        _createElementVNode("circle", {
          cx: "20",
          cy: "24",
          r: "1.2",
          fill: _ctx.variant === 'white' ? '#0d9488' : '#f0fdfa'
        }, null, 8, _hoisted_4),
        _createElementVNode("path", {
          d: "M30 32 Q36 24 34 20",
          "stroke-width": "2.5",
          "stroke-linecap": "round",
          stroke: _ctx.variant === 'white' ? '#ffffff' : '#0d9488',
          fill: "none"
        }, null, 8, _hoisted_5)
      ], 8, _hoisted_2),
      _createElementVNode("g", {
        fill: _ctx.variant === 'white' ? 'rgba(255,255,255,0.85)' : '#5eead4'
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("ellipse", {
          cx: "40",
          cy: "39",
          rx: "6.5",
          ry: "9",
          opacity: "0.9"
        }, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("circle", {
          cx: "41",
          cy: "28",
          r: "6"
        }, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("polygon", { points: "36,23 38,16 40,23" }, null, -1)),
        _cache[6] || (_cache[6] = _createElementVNode("polygon", { points: "42,23 44,16 46,23" }, null, -1)),
        _createElementVNode("polygon", {
          points: "40,30 41,31.5 42,30",
          fill: _ctx.variant === 'white' ? '#0d9488' : '#134e4a'
        }, null, 8, _hoisted_7),
        _createElementVNode("ellipse", {
          cx: "39",
          cy: "27",
          rx: "1",
          ry: "1.3",
          fill: _ctx.variant === 'white' ? '#0d9488' : '#f0fdfa'
        }, null, 8, _hoisted_8),
        _createElementVNode("ellipse", {
          cx: "43",
          cy: "27",
          rx: "1",
          ry: "1.3",
          fill: _ctx.variant === 'white' ? '#0d9488' : '#f0fdfa'
        }, null, 8, _hoisted_9),
        _createElementVNode("path", {
          d: "M45 35 Q50 30 52 26 Q53 24 51 25",
          "stroke-width": "2",
          "stroke-linecap": "round",
          stroke: _ctx.variant === 'white' ? 'rgba(255,255,255,0.85)' : '#5eead4',
          fill: "none"
        }, null, 8, _hoisted_10)
      ], 8, _hoisted_6),
      _createElementVNode("g", {
        fill: _ctx.variant === 'white' ? 'rgba(255,255,255,0.4)' : '#99f6e4',
        transform: "translate(28,48) scale(0.5)"
      }, _cache[7] || (_cache[7] = [
        _createStaticVNode("<ellipse cx=\"0\" cy=\"3\" rx=\"3\" ry=\"3.5\"></ellipse><circle cx=\"-3.5\" cy=\"-1\" r=\"1.5\"></circle><circle cx=\"-1\" cy=\"-3\" r=\"1.5\"></circle><circle cx=\"2\" cy=\"-3\" r=\"1.5\"></circle><circle cx=\"4.5\" cy=\"-1\" r=\"1.5\"></circle>", 5)
      ]), 8, _hoisted_11)
    ], 2)),
    _createElementVNode("span", {
      class: _normalizeClass([
        'font-title font-extrabold tracking-tight',
        _ctx.size === 'sm' ? 'text-lg' : _ctx.size === 'lg' ? 'text-3xl' : 'text-xl',
        _ctx.variant === 'white' ? 'text-white' : 'text-landing-secondary-800',
      ])
    }, [
      _cache[8] || (_cache[8] = _createTextVNode(" gumi")),
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.variant === 'white' ? 'text-landing-primary-200' : 'text-landing-primary-500')
      }, "vet", 2)
    ], 2)
  ], 2))
}
}

})